import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { AlarmAction } from "@/store/responses/types";

const Responses = namespace("responses");

@Component
export default class AlarmActionsMixin extends Vue {
	@Responses.State("currentAlarmAction") public currentAlarmActionFromStore: AlarmAction;

	public currentAlarmAction: AlarmAction = null;

	public created(): void {
		this.currentAlarmAction = { ...this.currentAlarmActionFromStore };
	}

	public get isEditing(): boolean {
		return this.currentAlarmAction.responseActionID > 0;
	}

	@Watch("$v.$invalid")
	@Emit("validation-changed")
	public handleValidationChange($invalid: boolean): boolean {
		return $invalid;
	}

	@Watch("currentAlarmAction", { deep: true })
	@Emit("alarm-action-details-changed")
	private handleAlarmActionDetailsChanged(): void {}
}
